export default __webpack_public_path__ + "static/media/Hanuman_langur_@_Bandhavgarh_National_Park_02.4ecef5d4.jpg";